import { FC, memo } from 'react'

import { Link } from '~/components/Link'
import { MathVaultLink } from '~/types/math-vault'
import SVGImage from '~/components/Image/SVGImage'

interface MenuItemProps {
  item: MathVaultLink
  isLink: boolean
  selected: string
  selectMenu: (path: string) => void
  level: number
}

const MenuItemComponent: FC<MenuItemProps> = ({ item, isLink, selected, selectMenu, level }) => {
  const path = item.path?.src ?? item.path
  const isSelected = selected.indexOf(path) === 0

  let fontSize = 'text-md'
  let lineHeight = 'h-20'
  switch (level) {
    case 1:
      fontSize = 'text-md '
      lineHeight = 'h-16'
      break
    case 2:
      fontSize = 'text-sm pt-2'
      lineHeight = 'h-10'
      break
    default:
      fontSize = 'text-xs pt-1'
      lineHeight = ''
  }

  const handleClick = (evt) => {
    evt.preventDefault()
    selectMenu(path)
  }

  if (isLink) {
    return (
      <Link
        className={`pl-2 flex items-center rounded ${
          isSelected ? item.activeClass.text : 'text-gray-link'
        } ${lineHeight}`}
        to={item.path}
      >
        {item.icon && <SVGImage alt={item.h1} imageClassName="w-10 shrink-0" srcKey={item.icon.src} />}
        <span className={`ml-4 leading-7 ${fontSize}`}>{item.h1}</span>
      </Link>
    )
  }

  return (
    <p
      className={`pl-2 flex items-center rounded cursor-pointer ${isSelected ? item.activeClass.text : 'text-gray-link'}
      ${lineHeight}`}
      onClick={handleClick}
    >
      {item.icon && <SVGImage alt={item.h1} imageClassName="w-10 shrink-0" srcKey={item.icon.src} />}
      <span className={`ml-4 leading-7 ${fontSize}`}>{item.h1}</span>
    </p>
  )
}
const MenuItem = memo(MenuItemComponent)

export default MenuItem
